import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';

const slides = featuredMovies;

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {slides.map((movie, index) => (
        <div
          key={movie.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={movie.image}
            alt={movie.title}
            className="w-full h-full object-cover"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4">
        <div className="w-full max-w-3xl">
          <div className="mb-4 flex items-center justify-center gap-2">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-500 rounded-xl">
              <i className="ri-movie-2-line text-2xl md:text-3xl text-background-50"></i>
            </div>
            <h1 className="text-3xl md:text-5xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
              春色影视
            </h1>
          </div>
          <p className="text-base md:text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            不缓冲流畅播放 · 高清免费在线观看 · 免费不收费<br className="hidden md:block" />
            秒开无卡顿极速影视 · 电影电视剧全集实时更新
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
            >
              <i className="ri-play-circle-fill mr-2"></i>立即观影
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap text-center backdrop-blur-sm cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>了解更多
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                  index === current ? 'bg-primary-500 w-6' : 'bg-white/40 hover:bg-white/60'
                }`}
                aria-label={`第${index + 1}张幻灯片`}
              />
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white backdrop-blur-sm transition-all duration-300 cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white backdrop-blur-sm transition-all duration-300 cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}